export enum BankAccountType {
  CurrentAccount = 'CurrentAccount',
  SavingsAccount = 'SavingsAccount',
  CashAccount = 'CashAccount',
  CreditCard = 'CreditCard',
  TrustAccount = 'TrustAccount',
  Other = 'Other',
}

export interface BankAccount {
  id: string;
  ownerId: string;
  buildingId: string;
  name: string;
  bankName?: string;
  accountType: BankAccountType;
  accountNumber?: string;
  sortCode?: string;
  currency: string;
  openingBalance: number; // in pence
  description?: string;
  isActive: boolean;
  /** Explicit s42 client/trust designation; absent means operating account. */
  trust?: boolean;
  isCompanyAccount?: boolean;
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
}
